const Nomatch = () => {
  return (
    <>
      <h1>Page not available</h1>
    </>
  );
};

export default Nomatch;
